export const TRANSFORM_RICH_TEXT = 'TRANSFORM_RICH_TEXT';
export const TRANSFORM_RICH_TEXT_SUCCESS = 'TRANSFORM_RICH_TEXT_SUCCESS';
export const TRANSFORM_RICH_TEXT_FAIL = 'TRANSFORM_RICH_TEXT_FAIL';
export const RESET_AI_TRANSFORM = 'RESET_AI_TRANSFORM';

/** Streaming-side status updates dispatched by the AI streaming hook. */
export const AI_TRANSFORM_STREAM_DONE = 'AI_TRANSFORM_STREAM_DONE';
export const AI_TRANSFORM_STREAM_ERROR = 'AI_TRANSFORM_STREAM_ERROR';
